import types from './types';

// const BLANK_SCHOOL = {
// 	dormMap: {},
// 	subDorms: [],
// 	subDormMap: {},
// 	transportTypes: [],
// 	typeList: [],
// 	dorms: [],
// 	interests: [],
// 	interestMap: {},
// 	leaveTypes: {},
// 	leaves: {map: {}, list: []},
// 	locations: {map: {}, list: []}
// }

const initialState = {
	loading: true,
	school: {
		dormMap: {},
		subDorms: [],
		subDormMap: {},
		transportTypes: [],
		typeList: [],
		dorms: [],
		leaveTypes: {},
		leaves: {map: {}, list: []},
		locations: {map: {}, list: []}
	},
	locations: {list: [], map: {}},
	leaves: {list: [], map: {}},
	dorms: {list: [], map: {}},

};

export default (state = initialState, action) => {
	switch (action.type) {
		/* Set search term  */
		case types.UPDATE_SCHOOL_INFO:
			return {
				...state,
				locations: action.payload.locations,
				leaves: action.payload.leaves,
				dorms: {list: action.payload.dorms, map: {}},
				school: {
					...action.payload,
					locations: {
						...action.payload.locations,
						list: action.payload.locations.list && action.payload.locations.list.length ? action.payload.locations.list.sort((locPre, locNxt) => {
							var namePre = locPre.name.toUpperCase(); // ignore upper and lowercase
							var nameNxt = locNxt.name.toUpperCase(); // ignore upper and lowercase
							if (namePre < nameNxt) {
							  return -1;
							}
							if (namePre > nameNxt) {
							  return 1;
							}
						  
							// names must be equal
							return 0;
						}) : action.payload.locations.list
					}
				},
				loading: false
			};
		// Clear search.
		case types.CLEAR_SEARCH: {
			return {
				search: ""
			};
		}
		default:
			return state;
	}
};
